export default function (chartData = []) {

  const xData = chartData.map(item => item.date)

  const total = chartData.map(item => item.total)
  const count = chartData.map(item => item.count)
  /**
   * @type {import('echarts').EChartsOption}
   */
  const option = {
    color: ['#4283EC', '#FEAE48'],
    title: {
      text: '电站趋势分析',
      subtext: '电站总数以及每月的新增电站数统计',
      left: 20,
      top: 10,
      textStyle: {
        color: '#000',
        fontSize: 16,
        fontWeight: 500,
        fontFamily: 'HarmonyOS Sans SC',
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    grid: {
      top: 80,
      bottom: 40,
      left: 80,
      right: 80,
    },
    legend: {
      right: 60,
      top: 20,
      itemWidth: 10,
      itemHeight: 10,
    },
    xAxis: [
      {
        type: 'category',
        data: xData,
        axisPointer: {
          type: 'shadow'
        },
        axisLine: {
          show: false
        }
      },
      {
        show: false,
        type: 'category',
        data: xData,
        axisPointer: {
          type: 'shadow'
        },
        axisLine: {
          show: false
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value} 个'
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          }
        }
      },
      {
        position: 'right',
        type: 'value',
        axisLabel: {
          formatter: '{value} 个'
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          }
        }
      },
    ],
    series: [
      {
        name: '电站',
        type: 'bar',
        tooltip: {
          valueFormatter: function (value) {
            return value + ' 个';
          }
        },
        barWidth: 16,
        data: total,
        itemStyle: {
          // [左上角, 右上角, 右下角, 左下角]
          borderRadius: [4, 4, 0, 0]
        }
      },
      {
        name: '新增电站',
        type: 'line',
        tooltip: {
          valueFormatter: function (value) {
            return value + ' 个';
          }
        },
        barWidth: 16,
        data: count,
        smooth: 0.2,
        xAxisIndex: 1,
        yAxisIndex: 1,
      },
    ]
  };
  return option
}
